import React from 'react'
import styled from 'styled-components/native'
import I18n from 'APP/I18n'
import IconCard from 'APP/Converse/IconCard'

const StyledNotice = styled(IconCard)`
  background-color: ${({ theme }) => theme.colors.selected};
`

export const InsuranceReimbursementNotice = () => (
  <StyledNotice
    testID="INSURANCE_REIMBURSEMENT_NOTICE"
    title={I18n.t('InsuranceReimbursementNotice.title')}
    description={I18n.t('InsuranceReimbursementNotice.body')}
    leftIcon={{
      src: 'info-outline',
      variant: 'materialIcons',
      color: 'text',
    }}
  />
)
